/**
 * https://mapicons.mapsmarker.com/markers/stores/computers-electronics/phones/?custom_color=8c8c8c
 */
// Import Static files
import eventAgendado from "@/assets/images/markers/event-agendado.png";
import eventReprogramado from "@/assets/images/markers/event-reprogramado.png";
import eventFinalizado from "@/assets/images/markers/event-finalizado.png";
import eventCancelado from "@/assets/images/markers/event-cancelado.png";
import eventEnProceso from "@/assets/images/markers/event-en_proceso.png";
// Import Static files
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import phonesRed from "@/assets/images/markers/phones_red.png";
import {
	addGroupOfMarkers,
	addPolylineToMap,
	calculateHereRoute,
	calculateRouteSnapToRoad,
	fitBoundsMarkerGroup,
} from "../../utils/HereMap";

let icons = [
	"https://cdn.mapmarker.io/api/v1/fa?icon=fa-id-badge&size=56&color=28C76F",
	`https://cdn.mapmarker.io/api/v1/pin?text=FA&size=40&background=D94B43&color=FFF&hoffset=-1`,
	phonesSuccess,
];

export default {
	generateMarkerIconEvent(statusId) {
		switch (statusId) {
			case 1:
				return "NOT_ASSIGNED";
				break;
			case 2:
				return eventAgendado;
				break;
			case 3:
				return eventReprogramado;
				break;
			case 4:
				return "DELAYED";
				break;
			case 5:
				return "ON_THE_WAY";
				break;
			case 6:
				return eventEnProceso;
				break;
			case 7:
				return eventFinalizado;
				break;
			case 8:
				return eventCancelado;
				break;
			default:
				return null;
				break;
		}
	},
	generateMarkerIconResource({active}) {
		if (active) return phonesSuccess;
		else return phonesRed;
	},
	drawProgramedRoute(data = [], optionsProgramedRoute, clearMarkerArray = false) {
		if (clearMarkerArray) this.markerArray = [];
		this.possitionArray = [];
		if (data !== null && data.length > 0) {
			data.forEach((element, index) => {
				this.addMarkerRoute(element.cy, element.cx, {...element, index: index + 1});
			});
			calculateHereRoute(this.possitionArray, {...optionsProgramedRoute});
			fitBoundsMarkerGroup(this.markerArray);
			setTimeout(() => {
				this.toggleMapSidebar(false);
			}, 700);
		} else {
			this.$vs.notify({
				color: "warning",
				title: this.$t("NoDating"),
				text: this.$t("NotScheduleDescription"),
			});
		}
	},
	drawExecuteRoute(data = [], optionsExecutedRoute, makeZoom = false) {
		this.possitionArray = [];
		this.markerArray = [];
		if (data !== null && data.length > 0) {
			this.possitionArray = data.map((element) => ({lat: +element.cy, lng: +element.cx, ...element}));
			calculateRouteSnapToRoad(this.possitionArray, {...optionsExecutedRoute});
			if (optionsExecutedRoute.lineWaypoints) {
				const options = {
					strokeColor: optionsExecutedRoute.lineWaypointsStrokeColor,
					strokeOpacity: optionsExecutedRoute.lineWaypointsStrokeOpacity,
					strokeWeight: optionsExecutedRoute.lineWaypointsStrokeWeight,
				};
				this.executedRoutePolyline = addPolylineToMap(this.possitionArray, options);
			}
			if (optionsExecutedRoute.showWaypoints) {
				const options = {
					strokeColor: "#000000",
					strokeWeight: 1,
					fillColor: optionsExecutedRoute.lineWaypointsStrokeColor,
					label: optionsExecutedRoute.waypointsLabel,
					dateText: this.$t("Object.statusOptions.Date"),
					hourText: this.$t("general.Hour"),
					distanceText: this.$t("OnDemand.Distance"),
					rasterText: this.$t("general.Raster") + " " + "No",
					of: this.$t("general.Of"),
				};
				addGroupOfMarkers.call(this, this.possitionArray, options);
			}
			setTimeout(() => {
				this.toggleMapSidebar(false);
			}, 700);
		} else {
			this.$vs.notify({
				color: "warning",
				title: this.$t("NoTracking"),
				text: this.$t("NotDataExecuteDescription"),
				time: 4000,
			});
		}
	},
	howLongLastTransmission(startTime) {
		const x = new Date(startTime);
		const now = new Date();
		let timeDiff = now - x;
		timeDiff /= 1000;

		const seconds = Math.round(timeDiff);
		timeDiff = Math.floor(timeDiff / 60);

		const minutes = Math.round(timeDiff % 60);
		timeDiff = Math.floor(timeDiff / 60);

		const hours = Math.round(timeDiff % 24);
		timeDiff = Math.floor(timeDiff / 24);

		const days = Math.round(timeDiff % 365);
		timeDiff = Math.floor(timeDiff / 365);

		const years = timeDiff;
		const locale = this.$t("Ago");
		let res = "";
		if (locale === "Ago") {
			if (years > 0) {
				res = `${years + (years > 1 ? " Years " : " Year ")} ${this.$t("Ago")}`;
			} else if (days > 0) {
				res = `${days + (days > 1 ? " Days " : " Day ")} ${this.$t("Ago")}`;
			} else if (hours > 0) {
				res = `${hours + (hours > 1 ? " Hrs " : " Hour ")} ${this.$t("Ago")}`;
			} else if (minutes > 0) {
				res = `${minutes + (minutes > 1 ? " Mins " : " Min ")} ${this.$t("Ago")}`;
			} else if (seconds > 0) {
				res = seconds + (seconds > 1 ? " sec ago" : "just now");
			} else if (isNaN(timeDiff)) {
				res = "Has never transmitted";
			} else {
				res = "Just Now";
			}
		} else {
			if (years > 0) {
				res = ` ${this.$t("Ago")} ${years + (years > 1 ? " Años " : " Año ")} `;
			} else if (days > 0) {
				res = ` ${this.$t("Ago")} ${days + (days > 1 ? "  Días " : "  Día ")} `;
			} else if (hours > 0) {
				res = ` ${this.$t("Ago")} ${hours + (hours > 1 ? " Horas " : " Hora ")} `;
			} else if (minutes > 0) {
				res = ` ${this.$t("Ago")} ${minutes + (minutes > 1 ? " Minutos " : " Minuto ")} `;
			} else if (seconds > 0) {
				res = seconds < 25 ? "Justo ahora" : `Hace ${seconds} Segundos`;
			} else if (isNaN(timeDiff)) {
				res = "Nunca ha transmitido";
			} else {
				res = "Justo ahora";
			}
		}
		return res;
	},
	/**
	 *
	 * @param {*} param0 color de relleno
	 * @param {*} param0 etiqueta del numero
	 */
	drawExecuteRouteWaypoints(data, options) {
		this.possitionArray = data.map((element) => ({lat: +element.cy, lng: +element.cx, ...element}));
		addGroupOfMarkers.call(this, this.possitionArray, options);
	},
	/**
	 *
	 * @param {*} param0 color de relleno
	 * @param {*} param0 etiqueta del numero
	 */
	drawAuxiliaryExecuteRoute(data, optionsExecutedRoute) {
		this.possitionArray = data.map((element) => ({lat: +element.cy, lng: +element.cx, ...element}));
		const options = {
			strokeColor: optionsExecutedRoute.lineWaypointsStrokeColor,
			strokeOpacity: optionsExecutedRoute.lineWaypointsStrokeOpacity,
			strokeWeight: optionsExecutedRoute.lineWaypointsStrokeWeight,
		};
		// tenemos alcance a esta variale siempre y cuando llamenos a la funcion con call o aply
		this.executedRoutePolyline = addPolylineToMap(this.possitionArray, options);
	},
	getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
		let R = 6371; // Radius of the earth in km
		let dLat = this.deg2rad(lat2 - lat1); // this.deg2rad below
		let dLon = this.deg2rad(lon2 - lon1);
		let a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
		let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		let d = R * c; // Distance in km
		return d;
	},

	deg2rad(deg) {
		return deg * (Math.PI / 180);
	},
};
